module.exports = __webpack_public_path__ + "static/media/PDF_51.f3a1622f.pdf";